import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

export function useEntity(resource, params = {}) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null && v !== "all"))
  ).toString();

  const load = useCallback(() => {
    setLoading(true);
    api
      .get(`/${resource}?${qs}`)
      .then((r) => {
        setItems(r.data.items);
        setTotal(r.data.total);
        setError(null);
      })
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
  }, [resource, qs]);

  useEffect(() => {
    load();
  }, [load]);

  return { items, total, loading, error, reload: load };
}

export const createItem = (resource, data) => api.post(`/${resource}`, data).then((r) => r.data);
export const updateItem = (resource, id, data) => api.put(`/${resource}/${id}`, data).then((r) => r.data);
export const archiveItem = (resource, id) => api.delete(`/${resource}/${id}`).then((r) => r.data);
export const deleteItem = (resource, id) => api.delete(`/${resource}/${id}?hard=true`).then((r) => r.data);
